export default __webpack_public_path__ + "Open_Roll_Large_Dual.png";